<template>
  <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <DynamicRender
          v-if="widgetsData && widgetsComputedReady && widgetsData.rowData"
          :template="control.customCode || ''"
          :data="widgetsData"
          :computed="widgetsComputedReady"
        />
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
        <div>
          <DynamicRender
            v-if="widgetsData && widgetsComputedReady && widgetsData.rowData"
            :template="control.customCode || ''"
            :data="widgetsData"
            :computed="widgetsComputedReady"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: ['control', 'labelPosition'],
  components: {
    DynamicRender,
  },
  data() {
    return {
      widgetsData: null,
      widgetsComputedReady: null,
      options: null,
      fbInst: null,
      dgInst: null,
      cellKey: null,
    }
  },
  computed: {
    ...mapState(['currentDash', 'dataGrid_options']),
  },
  methods: {
    onCmCodeChange(value) {
      this.control.value = value
    },
    save() {
      const data = {
        gridId: this.options.source,
        oName: `meta/${this.cellKey}/ccTemplate`,
        oValue: this.control.value,
      }

      db.dataGrid.options.saveOption(data, () => {
        this.inDisplayView = true
      })
    },
    dgCellChanged(cellKey) {
      if (cellKey !== this.cellKey) return

      this.dInst.widgetsData.rowData = this.fbInst.rowData
      this.widgetsData = Object.assign({}, this.dInst.widgetsData)
    },
  },
  created() {
    this.$nextTick(() => {
      this.dInst = this.$instByClass(this, 'dashboard-component')
      this.fbInst = this.$instByClass(this, 'form-builder-root')

      this.dInst.widgetsData.rowData = this.fbInst.rowData
      this.cellKey = this.control.propName

      this.dInst.widgetsData.gridId = this.fbInst.gridId

      if (this.fbInst.rowKey) {
        this.dInst.widgetsData.rowKey = this.fbInst.rowKey
      }

      this.fbInst.$on('dgCellChanged', this.dgCellChanged)

      this.widgetsData = Object.assign(
        { control: this.control },
        this.dInst.widgetsData
      )
      this.widgetsComputedReady = this.dInst.widgetsComputedReady
    })
  },
}
</script>
